import React from 'react';
import { Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import useAuth from '../hooks/useAuth';
import { PATHS_APP_OVERVIEW } from 'src/routes/paths';

const GuestGuard = ({ children }) => {
  const { isAuthenticated, error } = useAuth();

  if (error) {
    console.error(error);
  }

  if (isAuthenticated) {
    return <Navigate to={PATHS_APP_OVERVIEW.ROOT} />;
  }

  return <>{children}</>;
};

GuestGuard.propTypes = {
  children: PropTypes.node,
};

export default GuestGuard;
